module.exports = __webpack_public_path__ + "img/icon_classify_pre.cbb6c757.png";